// Central product catalogue with brand data + official product boards + lifestyle imagery
export const PRODUCT_BOARDS = {
  voltx: "https://customer-assets.emergentagent.com/job_a5d05ac1-3d02-4cad-955b-cc790acddfb1/artifacts/f7mr4dva_VOLTX%20R.jpeg",
  voltx_pet: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/9x519nb1_VOLTX%20PET.jpeg",
  onecola: "https://customer-assets.emergentagent.com/job_a5d05ac1-3d02-4cad-955b-cc790acddfb1/artifacts/972gifjs_ONECOLA%20BRAND.jpeg",
  onecola_pet: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/jqnumnvg_ONECOLA%20PET.jpeg",
  onecola_33cl: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/tsifw9c5_ONECOLA%2033CL.jpeg",
  onecola_grape: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/7tngjcdz_ONECOLA%20GRAPE%20JUICE.jpeg",
  onefresh: "https://customer-assets-jai6qajn.emergentagent.net/job_brew-excellence-2/artifacts/a1e204d901c476c3_OneFresh%20Juice%20Collection%20Display.png",
  maltora_premium: "https://customer-assets-jai6qajn.emergentagent.net/job_brew-excellence-2/artifacts/f623a65f071fedae_Maltora%20Premium%20Non-Alcoholic%20Malt%20Drink%20Showcase.png",
  maltora: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/jtakx4s7_MALTORA1.jpeg",
  maltora_original: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/5nhqtach_MALTORA.jpeg",
  maltora_m2: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/6b220ole_M2.jpeg",
  maltora_m4: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/1s79p30a_M4.jpeg",
  maltora_m5: "https://customer-assets.emergentagent.com/job_brew-excellence-2/artifacts/u81ena4k_M5.jpeg",
};

export const LIFESTYLE = {
  family: "https://images.unsplash.com/photo-1765582870011-ff3cfdb06700?auto=format&fit=crop&w=1600&q=80",
  africa_market: "https://images.unsplash.com/photo-1680713660046-67b7350ed679?auto=format&fit=crop&w=1600&q=80",
  supermarket: "https://images.pexels.com/photos/21582444/pexels-photo-21582444.jpeg?auto=compress&cs=tinysrgb&w=1600",
  factory: "https://images.unsplash.com/photo-1716643863806-989dd76ae093?auto=format&fit=crop&w=1600&q=80",
  sports: "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?auto=format&fit=crop&w=1600&q=80",
  handshake: "https://images.unsplash.com/photo-1638262052640-82e94d64664a?auto=format&fit=crop&w=1600&q=80",
  world: "https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?auto=format&fit=crop&w=1600&q=80",
  splash: "https://images.unsplash.com/photo-1459802071246-377c0346da93?auto=format&fit=crop&w=2000&q=80",
  cafe: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=1600&q=80",
  office: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1600&q=80",
  restaurant: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1600&q=80",
  outdoor: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=1600&q=80",
  water_pour: "https://images.unsplash.com/photo-1548839140-29a749e1cf4d?auto=format&fit=crop&w=1600&q=80",
  fruits: "https://images.unsplash.com/photo-1610832958506-aa56368176cf?auto=format&fit=crop&w=1600&q=80",
  malt: "https://images.unsplash.com/photo-1535958636474-b021ee887b13?auto=format&fit=crop&w=1600&q=80",
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1600&q=80",
  team: "https://images.unsplash.com/photo-1552581234-26160f608093?auto=format&fit=crop&w=1600&q=80",
  lab: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1600&q=80",
  bottling: "https://images.unsplash.com/photo-1532634733-cae1395e440f?auto=format&fit=crop&w=1600&q=80",
};

export const PRODUCTS = [
  {
    slug: "maltora",
    name: "Maltora",
    tagline: "Rich Taste. Pure Refreshment.",
    accent: "#8B5A2B",
    accentBg: "from-amber-900 to-neutral-950",
    hero: PRODUCT_BOARDS.maltora_premium,
    board: PRODUCT_BOARDS.maltora_premium,
    gallery: [PRODUCT_BOARDS.maltora_premium, PRODUCT_BOARDS.maltora, PRODUCT_BOARDS.maltora_m5, PRODUCT_BOARDS.maltora_m4],
    lifestyle: LIFESTYLE.malt,
    description:
      "Maltora is our flagship non-alcoholic premium malt drink, crafted from the finest barley malt for a rich, full-bodied taste. Enriched with essential vitamins and minerals, Maltora delivers wholesome refreshment for the whole family.",
    features: ["Rich Malt Taste", "Vitamin Enriched", "100% Non-Alcoholic", "Natural Goodness", "Premium Quality"],
    variants: [
      { name: "Original", note: "Classic full-bodied malt" },
    ],
    formats: ["250ml Slim Can", "330ml Standard Can", "500ml Tall Can", "330ml Bottle"],
    highlight: "Premium Malt Drink",
  },
  {
    slug: "onecola",
    name: "OneCola",
    tagline: "One Taste. One World.",
    accent: "#C81E1E",
    accentBg: "from-red-900 to-neutral-950",
    hero: PRODUCT_BOARDS.onecola_pet,
    board: PRODUCT_BOARDS.onecola_pet,
    gallery: [PRODUCT_BOARDS.onecola_pet, PRODUCT_BOARDS.onecola_33cl, PRODUCT_BOARDS.onecola_grape, PRODUCT_BOARDS.onecola],
    lifestyle: LIFESTYLE.family,
    description:
      "OneCola is the confident, modern cola built for a new generation. Bold flavour, iconic silhouette and world-class quality. Perfectly carbonated. Premium ingredients. One taste. One world.",
    features: ["Bold Cola Flavour", "Perfectly Carbonated", "Refreshing Taste", "Premium Quality", "Modern Packaging"],
    variants: [
      { name: "Original Taste", note: "The classic OneCola — bold and refreshing" },
      { name: "Zero Sugar", note: "All the taste, none of the sugar" },
      { name: "Diet", note: "Lighter, crisper finish" },
      { name: "Life", note: "Reduced-sugar with stevia" },
      { name: "Grape Juice", note: "100% real fresh — rich in Vitamin C" },
    ],
    formats: ["33cl Can", "1L PET Bottle", "500ml Bottle", "300ml Juice Can"],
    highlight: "Bold Taste. Real Refreshment.",
  },
  {
    slug: "onefresh",
    name: "OneFresh",
    tagline: "Pure Hydration. Real Refreshment.",
    accent: "#0F766E",
    accentBg: "from-teal-800 to-neutral-900",
    hero: PRODUCT_BOARDS.onefresh,
    board: PRODUCT_BOARDS.onefresh,
    gallery: [PRODUCT_BOARDS.onefresh, LIFESTYLE.fruits, LIFESTYLE.water_pour, LIFESTYLE.cafe],
    lifestyle: LIFESTYLE.fruits,
    description:
      "The OneFresh family brings you real freshness in every drop — from 100% fruit juices to premium still, sparkling and flavoured waters. Made with quality you can trust for a healthier, happier you.",
    features: ["Real Fruit Juice", "No Artificial Preservatives", "Rich in Vitamin C", "Natural Spring Water", "Zero Calories (Sparkling)"],
    variants: [
      { name: "Orange Juice", note: "100% real orange" },
      { name: "Mango Juice", note: "Rich tropical mango" },
      { name: "Apple Juice", note: "Crisp and refreshing" },
      { name: "Grape Juice", note: "Sweet purple grape" },
      { name: "Pineapple Juice", note: "100% pineapple, no sugar added" },
      { name: "Mixed Fruit", note: "Multi-fruit blend" },
      { name: "Still Water", note: "Natural spring water" },
      { name: "Sparkling Original", note: "Crisp bubbles" },
      { name: "Sparkling Lime", note: "Zesty lime" },
      { name: "Sparkling Berry", note: "Berry twist" },
      { name: "Flavoured Lemon", note: "Low-calorie lemon" },
      { name: "Flavoured Strawberry", note: "Light strawberry" },
      { name: "Flavoured Cucumber Lime", note: "Wellness refresh" },
    ],
    formats: ["200ml", "330ml", "500ml", "1L", "1.5L", "2L"],
    highlight: "One Family. Many Choices.",
  },
  {
    slug: "voltx",
    name: "VoltX",
    tagline: "Pure Energy. Max Performance.",
    accent: "#F59E0B",
    accentBg: "from-yellow-900 to-neutral-950",
    hero: PRODUCT_BOARDS.voltx,
    board: PRODUCT_BOARDS.voltx,
    lifestyle: LIFESTYLE.sports,
    description:
      "VoltX is more than an energy drink. It's the power to push harder, go further and achieve more. B-Vitamins, electrolytes, zero crash. Feel the charge. Live the VoltX.",
    features: ["Boosts Energy", "Improves Focus", "Enhances Performance", "Zero Crash", "B-Vitamins + Electrolytes"],
    variants: [
      { name: "Original", note: "Classic energy" },
      { name: "Sugar Free", note: "Zero sugar performance" },
      { name: "Tropical", note: "Tropical burst" },
      { name: "Citrus", note: "Lemon lime" },
      { name: "Extra Strength", note: "Maximum power" },
      { name: "Max", note: "Extra caffeine formula" },
      { name: "Zero", note: "Zero sugar, zero calories" },
    ],
    formats: ["250ml Can", "500ml Bottle"],
    highlight: "Power Your Day. Fuel Your Dreams.",
  },
  {
    slug: "onespring",
    name: "OneSpring",
    tagline: "Pure Hydration. Real Refreshment.",
    accent: "#0369A1",
    accentBg: "from-sky-900 to-neutral-900",
    hero: LIFESTYLE.water_pour,
    board: LIFESTYLE.water_pour,
    gallery: [LIFESTYLE.water_pour, LIFESTYLE.outdoor, LIFESTYLE.office, LIFESTYLE.splash],
    lifestyle: LIFESTYLE.water_pour,
    description:
      "OneSpring is premium spring drinking water for a healthier life. Advanced multi-stage purification, balanced natural minerals, and packaging designed for every moment — from home to sport to the boardroom.",
    features: ["Natural Spring Source", "Balanced Minerals", "Advanced Purification", "PET Recyclable", "Perfect pH"],
    variants: [{ name: "Still", note: "Everyday hydration" }],
    formats: ["330ml", "500ml", "750ml", "1L", "1.5L"],
    highlight: "Pure. Balanced. Essential.",
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const AFRICA_COUNTRIES = [
  "Nigeria", "Ghana", "Kenya", "South Africa", "Uganda", "Tanzania", "Rwanda",
  "Cameroon", "Senegal", "Ivory Coast", "Zambia", "Botswana", "Namibia",
  "Zimbabwe", "Ethiopia",
];

export const CORE_VALUES = [
  { title: "Integrity", desc: "We do what is right, always." },
  { title: "Innovation", desc: "We invent better beverages for tomorrow." },
  { title: "Quality", desc: "World-class standards in every bottle." },
  { title: "Respect", desc: "We honour our people, partners and planet." },
  { title: "Sustainability", desc: "Responsible business for the long-term." },
  { title: "Customer First", desc: "The consumer is at the heart of every decision." },
  { title: "Global Excellence", desc: "International standards. Local relevance." },
  { title: "Community Development", desc: "We invest where we operate." },
];

export const TIMELINE = [
  { year: "2026", title: "UK Incorporation", desc: "Scitygate Brewing Company Ltd incorporated in the United Kingdom on 6 July 2026 (Company No. 17323558)." },
  { year: "2026", title: "Brand Portfolio", desc: "Development of five founding brand identities underway: Maltora, OneCola, OneFresh, OneSpring and VoltX." },
  { year: "2026", title: "Manchester HQ", desc: "Head office established at Halifax House, 93–101 Bridge Street, Manchester M3 2GX, United Kingdom." },
  { year: "Planned", title: "Product Development", desc: "Formulation, packaging and quality specifications for each brand in active development." },
  { year: "Planned", title: "Manufacturing Partnerships", desc: "Building relationships with UK and international contract manufacturers and co-packers." },
  { year: "Planned", title: "Distribution Launch", desc: "First commercial availability subject to completion of product development and partner onboarding." },
];

export const WHY_SBC = [
  { title: "International Quality", desc: "Every batch built to global food-safety standards." },
  { title: "Premium Ingredients", desc: "Sourced responsibly, tested rigorously." },
  { title: "Modern Packaging", desc: "Eye-catching designs. Recyclable materials." },
  { title: "Reliable Supply", desc: "Consistent volumes, transparent logistics." },
  { title: "Export Ready", desc: "Documentation, compliance, freight — sorted." },
  { title: "Consumer Safety", desc: "Traceable from raw ingredient to shelf." },
  { title: "Research & Development", desc: "In-house labs continuously innovate." },
  { title: "Quality Assurance", desc: "ISO-aligned QA and audit protocols." },
];

export const SUSTAINABILITY = [
  { title: "Plastic Recycling", desc: "Closed-loop PET recycling by 2027 across all markets." },
  { title: "Energy Efficiency", desc: "Rooftop solar and low-carbon logistics." },
  { title: "Water Stewardship", desc: "Water positive by 2030 in every plant we operate." },
  { title: "Community Investment", desc: "Local sourcing, jobs and social programmes." },
  { title: "Responsible Packaging", desc: "Reduce, reuse, recycle across every SKU." },
];

export const QUALITY = [
  { title: "Manufacturing Standards", desc: "GMP-aligned production." },
  { title: "Food Safety", desc: "HACCP food-safety systems." },
  { title: "Laboratory Testing", desc: "Every batch tested for micro, chemistry and sensory." },
  { title: "Batch Traceability", desc: "End-to-end traceable manufacturing." },
  { title: "Quality Control", desc: "Zero-defect philosophy at every stage." },
  { title: "International Compliance", desc: "FSSC 22000, ISO 9001 aligned." },
];

export const CAREERS_TRACKS = [
  { title: "Graduate Programme", desc: "Two-year rotation across manufacturing, R&D and commercial." },
  { title: "Sales", desc: "Modern trade, traditional trade and export sales." },
  { title: "Engineering", desc: "Process, packaging and utility engineering." },
  { title: "Marketing", desc: "Brand, digital, insights and shopper marketing." },
  { title: "Finance", desc: "FP&A, treasury, controllership and audit." },
  { title: "Logistics", desc: "Supply planning, warehousing and export freight." },
];
